// extracted by mini-css-extract-plugin
export default {"tabs":"economics-editor_tabs__IZIki","parentTabs":"economics-editor_parentTabs__MMOiy"};